export default "__VITE_ASSET__dada7fa2__"